import BaseService from './base';
import request from '@/utils/request';

export interface SchoolViewModel {
  id?: number;
  name?: string;
  maxRegisterDate?: string;
  maxRegisterCount?: number;
  registerCode?: string;
}

export class SchoolService extends BaseService<SchoolViewModel> {
  protected serviceApi: string = 'School';

  get NewModel(): SchoolViewModel {
    return {
      id: 0,
      name: '',
      registerCode: '',
    };
  }

  public RefreshCode() {
    return request({
      url: `${this.serviceApi}/RefreshCode`,
      method: 'get',
    });
  }

  public GetMySchool() {
    return this.GetUrl('/GetMySchool');
  }
}
